module.exports = __webpack_public_path__ + "static/img/8431_phase_function_Paper_Points.e74a497.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/8431_phase_function_Paper_Points.png
// module id = Mbw8
// module chunks = 0